import { updateItemInCollection } from "directus/src/operations";

export async function updateClientContext({ item, caseStudyId }) {
  try {
    const query = {
      fields: ["*","industry_v1.type","industry_v1.id"],
    };

    const data = await updateItemInCollection(
      "case_studies",
      caseStudyId,
      item,
      query
    );

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
